.vc-toolbox-btn,
.vc-toolbox-icon {
    -webkit-app-region: no-drag;
}

.vc-toolbox-icon {
    color: var(--interactive-normal);
}

.vc-toolbox-btn[class*="selected"] .vc-toolbox-icon {
    color: var(--interactive-active);
}

.vc-toolbox-btn:hover .vc-toolbox-icon {
    color: var(--interactive-hover);
}
